var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"format":"YYYY-MM-DD ddd HH:mm","show-time":{ defaultValue: _vm.moment('00:00', 'HH:mm') },"valueFormat":"YYYY-MM-DD HH:mm:ss"},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }